import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Pro Immigrant Pro American Comedy</p>
        <h1>Laugh Together, Celebrate Diversity</h1>
        <p className="lede">
          Join us in a comedic journey that embraces the spirit of immigration and the joy of American culture. 
          Experience humor that unites us all, regardless of background.
        </p>
        <div className="cta-row">
          <a href="#join" target="_blank">
            Join the Fun
          </a>
          <a href="#about" target="_blank" className="secondary">
            Learn More
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Experience Unique Comedy</h2>
          <p>
            Discover performances that highlight the richness of immigrant stories through laughter and joy.
          </p>
        </article>
        <article>
          <h2>Connect with Community</h2>
          <p>
            Engage with a diverse audience that shares a passion for humor and inclusivity.
          </p>
        </article>
        <article>
          <h2>Support the Cause</h2>
          <p>
            Your participation helps promote a culture of acceptance and understanding through the power of comedy.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;